import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

import "./HeaderMain.css";

const HeaderMain = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); 

  const handleDropdownToggle = (id) => {
    if (window.innerWidth >= 992) return; 
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

  const closeMobileMenu = () => {
    const menu = document.getElementById("mainNavbar");
    if (menu && window.innerWidth < 992) {
      menu.classList.remove("show");
    }
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSmoothScroll = (sectionId) => {
    const currentPath = window.location.pathname;

    if (currentPath === "/") {
      const target = document.getElementById(sectionId);
      if (target) {
        window.scrollTo({
          top: target.offsetTop - 100,
          behavior: "smooth",
        });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }

    closeMobileMenu();
  };

  return (
    <header className={`header-main ${isScrolled ? "transparent" : ""}`}>
      <nav className="navbar navbar-expand-lg shadow-sm">
        <div className="container-fluid px-4">

          {/* LOGO */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="main-logo me-2" />
          </Link>

          {/* BOTÓN MÓVIL */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENÚ PRINCIPAL */}
          <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">
            <ul className="navbar-nav align-items-center">

              {/* INICIO */}
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={closeMobileMenu}>
                  Inicio
                </Link>
              </li>

              {/* NOSOTROS */}
              <li className={`nav-item dropdown ${openDropdown === "nosotros" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("nosotros");
                  }}
                >
                  Nosotros
                </a>

                <ul className={`dropdown-menu ${openDropdown === "nosotros" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/nosotros/presentacion" onClick={closeMobileMenu}>Presentación</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/mision" onClick={closeMobileMenu}>Misión, Visión y Valores</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/organizacion" onClick={closeMobileMenu}>Organización Institucional</Link></li>

                  <li><hr className="dropdown-divider" /></li>

                  <li><Link className="dropdown-item" to="/nosotros/autoridades" onClick={closeMobileMenu}>Autoridades</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/planaDocente" onClick={closeMobileMenu}>Plana Docente</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/localInstitucional" onClick={closeMobileMenu}>Local</Link></li>
                </ul>
              </li>

              {/* PROGRAMAS */}
              <li className={`nav-item dropdown ${openDropdown === "programas" ? "show" : ""}`}>
                  <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("programas");
                  }}
                >
                  Programas de Estudios
                </a>

                <ul className={`dropdown-menu ${openDropdown === "programas" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/programas/arquitectura-de-plataformas-y-sti" onClick={closeMobileMenu}>Arquitectura de Plataformas y STI</Link></li>
                  <li><Link className="dropdown-item" to="/programas/contabilidad" onClick={closeMobileMenu}>Contabilidad</Link></li>
                  <li><Link className="dropdown-item" to="/programas/enfermeria-tecnica" onClick={closeMobileMenu}>Enfermería Técnica</Link></li>
                  <li><Link className="dropdown-item" to="/programas/mecatronica-automotriz" onClick={closeMobileMenu}>Mecatrónica Automotriz</Link></li>
                  <li><Link className="dropdown-item" to="/programas/farmacia-tecnica" onClick={closeMobileMenu}>Farmacia Técnica</Link></li>
                </ul>
              </li>

              {/* ADMISION */}
              <li className={`nav-item dropdown ${openDropdown === "admision" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("admision");
                  }}
                >
                  Admisión y Matrícula
                </a>

                <ul className={`dropdown-menu ${openDropdown === "admision" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="admision/admision_" onClick={closeMobileMenu}>Admisión 2026</Link></li>
                  <li><Link className="dropdown-item" to="admision/matricula" onClick={closeMobileMenu}>Matrícula</Link></li>
                  <li><Link className="dropdown-item" to="admision/becas" onClick={closeMobileMenu}>Becas y Créditos</Link></li>
                </ul>
              </li>

              {/* TRANSPARENCIA */}
              <li className={`nav-item dropdown ${openDropdown === "transparencia" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("transparencia");
                  }}
                >
                  Transparencia
                </a>

                <ul className={`dropdown-menu ${openDropdown === "transparencia" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="trasparencia/documentos" onClick={closeMobileMenu}>Documentos de Gestión</Link></li>
                  <li><Link className="dropdown-item" to="trasparencia/estadistica" onClick={closeMobileMenu}>Estadísticas</Link></li>
                  <li><Link className="dropdown-item" to="trasparencia/inversiones" onClick={closeMobileMenu}>Inversiones y Recursos</Link></li>
                  <li><Link className="dropdown-item" to="trasparencia/reclamos" onClick={closeMobileMenu}>Libro de Reclamaciones</Link></li>
                  <li><Link className="dropdown-item" to="trasparencia/licenciamiento" onClick={closeMobileMenu}>Licenciamiento</Link></li>
                </ul>
              </li>

              {/* TRÁMITES */}
              <li className={`nav-item dropdown ${openDropdown === "tramites" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("tramites");
                  }}
                >
                  Trámites
                </a>

                <ul className={`dropdown-menu ${openDropdown === "tramites" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="tramites/TUPA" onClick={closeMobileMenu}>TUPA</Link></li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdhYcNFtPkouQIS7IqA80efoYTgPwa24RBLgH-aYX0cXkCxxg/viewform"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeMobileMenu}
                    >
                      Mesa de Partes
                    </a>
                  </li>
                </ul>
              </li>

              {/* CONTACTO */}
              <li className="nav-item">
                <Link className="nav-link" to="/contactanos" onClick={closeMobileMenu}>
                  Contáctanos
                </Link>
              </li>

              {/* SERVICIOS */}
              <li className={`nav-item dropdown ${openDropdown === "servicios" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("servicios");
                  }}
                >
                  Servicios
                </a>

                <ul className={`dropdown-menu ${openDropdown === "servicios" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="servicios/biblioteca" onClick={closeMobileMenu}>Biblioteca Digital</Link></li>
                  <li><Link className="dropdown-item" to="servicios/complementarios" onClick={closeMobileMenu}>Servicios Complementarios</Link></li>
                  <li><Link className="dropdown-item" to="servicios/bolsa" onClick={closeMobileMenu}>Bolsa Laboral</Link></li>
                  <li><Link className="dropdown-item" to="servicios/intranet" onClick={closeMobileMenu}>Intranet</Link></li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://partediariojva.blogspot.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeMobileMenu}
                    >
                      Parte Diario 2025
                    </a>
                  </li>
                </ul>
              </li>

              {/* OTRAS PÁGINAS */}
              <li className={`nav-item dropdown ${openDropdown === "otras" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("otras");
                  }}
                >
                  Otras Páginas
                </a>

                <ul className={`dropdown-menu ${openDropdown === "otras" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="otrasPaginas/enlaces" onClick={closeMobileMenu}>Links Institucionales</Link></li>
                  <li><Link className="dropdown-item" to="otrasPaginas/comunicados" onClick={closeMobileMenu}>Comunicados</Link></li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default HeaderMain;
